import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { readContract } from '@wagmi/core';
const abi = require('src/contracts/abi-dev/pdogv2.json');

@Injectable({
  providedIn: 'root'
})
export class V2ContractService {
  provider: string;
  

  async getDecimals() {
    const decimals:any = await readContract({
      address: environment.ETH_CONTRACT_ADDRESS as any,
      abi: abi,
      functionName: 'decimals',
      args:[]
    })

    return decimals;
  }

  async getBalance(address) {
    const balance:any = await readContract({
      address: environment.ETH_CONTRACT_ADDRESS as any,
      abi: abi,
      functionName: 'balanceOf',
      args:[address]
    })

    return balance;
  }

  async getAllowance(ownerAddr, spenderAddr) {
    const allowance:any = await readContract({
      address: environment.ETH_CONTRACT_ADDRESS as any,
      abi: abi,
      functionName: 'allowance',
      args:[ownerAddr,spenderAddr]
    })
    return allowance;
  }
}
